var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStratelaLogoWhite1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1025.95 202.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.22,129.71l19.92-21.74c-18.39-16.85-19.64-45.43-2.79-63.82,16.85-18.39,45.43-19.64,63.82-2.79l-.25.28h0l20.18-22.02C94.7-8.24,47.47-6.18,19.62,24.22c-27.86,30.4-25.8,77.63,4.61,105.49Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "logoClass1",
    d: "m101.11,72.93l-19.92,21.74c18.39,16.85,19.64,45.43,2.79,63.82-16.85,18.39-45.43,19.64-63.82,2.79l.25-.28h0L.23,183.02c30.4,27.86,77.63,25.8,105.49-4.61,27.86-30.4,25.8-77.63-4.61-105.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logoClass1",
    d: "m101.11,72.93l-19.92,21.74c18.39,16.85,19.64,45.43,2.79,63.82-16.85,18.39-45.43,19.64-63.82,2.79l.25-.28h0L.23,183.02c30.4,27.86,77.63,25.8,105.49-4.61,27.86-30.4,25.8-77.63-4.61-105.49Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "logoClass1",
    d: "m202.66,47.86V0h-29.49v47.87h-29.49v29.43h29.49v125.33h29.49v-125.33h29.47c5.26-11.49,13.11-21.56,22.79-29.46l-52.27.02Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "logoClass1",
    d: "m318.08,77.33c4.15-7.16,9.25-13.82,15.25-19.82,3.54-3.54,7.31-6.76,11.27-9.66h-38.06c-34.95,0-63.39,28.44-63.39,63.39v91.26h29.49v-91.26c0-18.69,15.21-33.9,33.9-33.9h11.54Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "logoClass1",
    d: "m478.44,47.85h-29.49v78.12c-.39,26.08-21.72,47.18-47.89,47.18s-47.91-21.49-47.91-47.91,21.49-47.91,47.91-47.91c11.1,0,21.33,3.81,29.46,10.17v-33.84c-9.08-3.74-19.03-5.82-29.46-5.82-42.74,0-77.39,34.65-77.39,77.39s34.65,77.39,77.39,77.39c18.08,0,34.71-6.2,47.89-16.59v16.59h29.49V47.85Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "logoClass1",
    d: "m555.87,47.85V0h-29.49v47.85h-29.49v29.49h29.49v125.3h29.49v-125.3h29.45c4.15-7.16,9.25-13.82,15.25-19.83,3.54-3.54,7.31-6.76,11.27-9.66h-55.97Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7",
    "data-name": "Layer 7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "logoClass1",
    d: "m744.68,137.82c.67-4.09,1.02-8.29,1.02-12.58,0-42.74-34.65-77.39-77.39-77.39s-77.39,34.65-77.39,77.39,34.65,77.39,77.39,77.39c27.8,0,52.18-14.66,65.82-36.67l-28.51-10.72c-8.79,10.91-22.25,17.91-37.31,17.91-22.06,0-40.68-15-46.22-35.33h122.59Zm-76.37-60.48c20.46,0,37.96,12.9,44.82,30.99h-89.63c6.85-18.09,24.35-30.99,44.82-30.99Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8",
    "data-name": "Layer 8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "logoClass1",
    x: 763.91,
    y: 0,
    width: 29.49,
    height: 202.64
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "logoClass1",
    d: "m966.61,47.85h-29.49v16.59c-13.17-10.39-29.81-16.59-47.89-16.59-42.74,0-77.39,34.65-77.39,77.39s34.65,77.39,77.39,77.39c10.43,0,20.38-2.07,29.46-5.81v-33.85c-8.13,6.36-18.36,10.17-29.46,10.17-26.42,0-47.91-21.49-47.91-47.91s21.49-47.91,47.91-47.91,47.41,21.01,47.89,47.02v78.28h29.49V47.85Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10",
    "data-name": "Layer 10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "logoClass1",
    points: "985 187.29 991.73 187.29 991.73 202.64 995.38 202.64 995.38 187.29 1002.12 187.29 1002.12 184.2 985 184.2 985 187.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logoClass1",
    d: "m1021.44,184.2l-4.91,10.08c-.36.72-.79,1.67-1.3,2.85-.46-1.07-.89-2.02-1.29-2.84l-4.91-10.09h-4.51v18.43h3.65v-8.93c0-1.16-.02-2.4-.07-3.7.32.7.64,1.37.96,2l5.24,10.63h1.87l5.24-10.62c.31-.62.63-1.29.96-2-.05,1.31-.07,2.55-.07,3.7v8.93h3.65v-18.43h-4.51Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStratelaLogoWhite1);
export default __webpack_public_path__ + "static/media/Stratela_logo_white-1.338a03dfae9dc4af192c1103ccf1ae77.svg";
export { ForwardRef as ReactComponent };